export const allowedPlatforms = [
  "Linkedin",
  "Facebook",
  "Google",
  "Pinterest",
  "TikTok",
];
